<template>
    <v-col align-self="auto" cols="12" xl="3" lg="5" md="6" sm="8">
        <div class="d-block text-center my-6 py-4">
            <img :src="getLogo()" height="60"/>
        </div>

        <v-card elevation="2" class="pa-6 dddark" :loading="loading" :disabled="loading">
            <div class="text-center pt-6 mt-6 mb-3">
                <span class="d-block text-h4 py-2">{{ $t('components.LoginForm.FormTitle') }}</span>
                <span class="d-block text-subtitle-1">{{ $t('components.LoginForm.FormSubtitle') }}</span>
            </div>
            <v-card-text class="pa-6">
                <v-alert v-if="error" dense outlined type="error">{{ error }}</v-alert>

                <v-form ref="form" id="form" v-model="valid" @submit.prevent="login">
                    <v-text-field 
                        solo light
                        v-model="email" 
                        class="dd-input"
                        :rules="[rules.required, rules.email]"
                        :label="$t('components.LoginForm.EmailLabel')"
                        hint="example@domain.com"/>
                    <v-text-field 
                        solo light
                        v-model="password"
                        class="dd-input"
                        :type="showPass ? 'text' : 'password'"
                        :label="$t('components.LoginForm.PasswordLabel')" 
                        :rules="[rules.required, rules.password]"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPass = !showPass"/>

                    <v-btn 
                        block
                        type="submit" 
                        form="form" 
                        color="success" 
                        elevation="1" 
                        class="text-h6"
                        style="text-transform: none" 
                        height="56px"
                        :disabled="!valid">
                        {{ $t('components.LoginForm.LoginButton') }}
                    </v-btn>
                </v-form>
            </v-card-text>
            <v-card-actions class="py-6 text-center d-block text-body-2">
                <router-link class="text-decoration-none" :to="{ name: 'reset-password', params: { locale: this.$i18n.locale } }">
                    {{ $t('components.LoginForm.ResetPasswordButton') }}
                </router-link>
                <p>Questions? Contact our <a href="mailto:reporting@getdeardoc.com">support team</a>.</p>
            </v-card-actions>
        </v-card>
    </v-col>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';

/**
 * LoginForm component includes the required fields and functions to perform an
 * user login process. It uses the AuthAPI class to wrap AWS Cognito service.
 */
export default {
    name: 'LoginForm',
    data: () => ({
        valid: true,
        loading: false,
        email: '',
        password: '',
        showPass: false,
        error: '',
        rules: {
            required: value => !!value || 'Required.',
            password: value => {
                if (!value || value.length < 8) return 'Min. length 8 characters (including at least 1 number and a mixture of uppercase and lowercase letters).';
                else if (!value.match('[a-z]+')) return 'At least one lowercase letter.';
                else if (!value.match('[A-Z]+')) return 'At least one uppercase letter.';
                else if (!value.match('[0-9\\W]+')) return 'At least one number or symbol.';
                return true;
            },
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        }
    }),
    methods: {
        getLogo() {
            const { isDark } = this.$vuetify.theme;
            return isDark ? '/logow.svg' : '/logo.svg';
        },
        async login() {
            const { email, password } = this;
            this.toggleLoading();

            const [ success, result ] = await AuthAPI.login(email, password);
            if (success) {
                window.gtag('event', 'user_logged', { value: email });
                
                let route = { name: 'dashboard' };
                const { challengeName } = result;
                if (challengeName === "NEW_PASSWORD_REQUIRED") {
                    route.name = 'new-password';
                    route.params = { user: result }; 
                }

                this.$router.push(route);
            }

            this.error = result.message;
            this.toggleLoading();
        },
        toggleLoading() {
            if (this.loading) {
                this.loading = false;
                this.$refs.form.reset();
            } else this.loading = true;
        }
    }
}
</script>